import React, {useRef, useEffect} from 'react'
import {Typography, TextField, InputAdornment, Grid, withStyles} from '@material-ui/core'

import InfoTooltip from '../../common/InfoTooltip'
import DeleteButton from '../../common/DeleteButton'
import AddButton from '../../common/AddButton'
import useModalState from '../../../hooks/useModalState'
import styles from '../styles/TestSetup.styles'

const MultipleChoiceOptions = ({
  classes,
  question,
  disableInputs,
  maxAnswers,
  addChoice,
  removeChoice,
  validateFields,
  currentQuestion,
  setChoice,
  choiceErrors,
}) => {
  const [isMaxAnswersTooltipOpen, openMaxAnswersTooltip, closeMaxAnswersTooltip] = useModalState(
    false,
  )

  const lastChoiceInputRef = useRef(null)

  useEffect(() => {
    if (lastChoiceInputRef.current) {
      lastChoiceInputRef.current.scrollIntoView({behavior: 'smooth'})
    }
  }, [question.choices])

  const getInputRef = index => {
    if (index === question.choices.length - 1) {
      return {
        inputRef: ref => {
          lastChoiceInputRef.current = ref
        },
      }
    }

    return {}
  }

  const renderChoices = () => {
    return question.choices.map((choice, index) => (
      <TextField
        {...getInputRef(index)}
        key={index}
        value={choice}
        onChange={({target}) => {
          setChoice(target.value.trimStart(), index)
          validateFields(currentQuestion)
        }}
        variant="outlined"
        className={classes.nameInput}
        InputProps={{
          classes: {
            root: classes.nameInputOutline,
            notchedOutline: choiceErrors[index] ? classes.errorOutline : classes.notchedOutline,
          },
          endAdornment: !disableInputs ? (
            <InputAdornment position="end">
              <DeleteButton
                onClick={() => removeChoice(index)}
                disabled={question.choices.length <= 2}
              />
            </InputAdornment>
          ) : null,
          readOnly: disableInputs,
          onBlur: () => {
            setChoice(choice.trim(), index)
            validateFields(currentQuestion)
          },
        }}
        placeholder="Type your answer"
        helperText={choiceErrors[index]}
        FormHelperTextProps={{
          className: classes.inputErrorText,
          errormessage: 'true',
        }}
        disabled={disableInputs}
      />
    ))
  }

  return (
    <>
      <Typography variant="h6" className={classes.sectionTitle} style={{width: 'max-content'}}>
        Answer
        <InfoTooltip
          text={
            <div>
              <span>Recommended Survey Answers:</span>
              <ul style={{margin: '8 8 0 0', paddingLeft: 20, lineHeight: '24px'}}>
                <li>Yes/No</li>
                <li>True/False</li>
                <li>Rating Scales</li>
                <ul>
                  <li>Type 1:</li>
                  <ul>
                    <li>Very Likely</li>
                    <li>Somewhat Likely</li>
                    <li>Somewhat Unlikely</li>
                    <li>Very Unlikely</li>
                  </ul>
                  <li>Type 2:</li>
                  <ul>
                    <li>Strongly Agree</li>
                    <li>Somewhat Agree</li>
                    <li>Somewhat Disagree</li>
                    <li>Strongly Disagree</li>
                  </ul>
                </ul>
              </ul>
            </div>
          }
          placement="right"
        />
      </Typography>
      {renderChoices()}
      {!disableInputs && (
        <Grid container style={{alignItems: 'center'}}>
          {question.choices.length >= maxAnswers ? (
            <InfoTooltip
              text={`You can only add a maximum of ${maxAnswers} answers.`}
              placement="left"
              open={isMaxAnswersTooltipOpen}
              showIcon={false}
            >
              <AddButton
                disableRipple
                className={classes.disabledAddButton}
                onMouseEnter={openMaxAnswersTooltip}
                onMouseLeave={closeMaxAnswersTooltip}
              />
            </InfoTooltip>
          ) : (
            <AddButton onClick={addChoice} />
          )}
          <Typography>Add New Answer</Typography>
        </Grid>
      )}
    </>
  )
}

export default withStyles(styles)(MultipleChoiceOptions)
